// extracted by mini-css-extract-plugin
module.exports = {"percent-input":"selectTypeDiscount_percent-input__30MG5","select-type-discount":"selectTypeDiscount_select-type-discount__3fL-G"};